import xImage from "../images/social-media/x-logo-resized.png"

function Footer() {
    return (
        <footer>
            <div className="inner-footer">
                <div className="footer-left">
                    <p>
                        Liskov is a Melbourne based tech education startup. It's a company run by devs and teachers from the top down, and committed to the best coding education in Melbourne. 
                    </p>
                    <div className="social-media-section">
                        <div className="social-media-element">
                            {/* <a href="#" className="fa fa-facebook">
                                <div className="coming-soon">
                                    coming soon..
                                </div>
                            </a> */}
                        </div>
                        <div className="social-media-element">
                            {/* <a href="#" className="fa fa-twitter"/>
                                <div className="coming-soon">
                                    coming soon..
                                </div>
                            </a> */}
                        </div>
                    </div>
                    <p>
                        We aim to provide high quality education and a realistic transition to a job in coding, with solid coding foundations to let you take control over where you take your career as a developer.
                    </p>
                    <p>
                        All voxel art designed using the super cool work of the good people at{" "}
                        <a href="https://rooms.xyz" target="_blank" rel="noopener noreferrer">
                            ROOMS.XYZ
                        </a>
                        . Check them out!
                    </p>
                    <div className="footer-contact">
                        <p className='phone-call'>
                        If your key interest is learning to code, call MATT on: 
                            <div className="phone-number">
                                <a href="tel:+61411867667">+61 411 867 667</a>
                            </div>
                        </p>
                        <p className='phone-call'>
                            If your key interest is learning UX design, call MICHAEL on: 
                            <div className="phone-number">
                                <a href="tel:+61414133958">+61 414 133 958</a>
                            </div> 
                        </p>
                    </div>
                </div>
                <div className="footer-right">
                    <p>follow us on..</p>
                    <div className="right-footer-link">
                        <div>
                            <a href="https://twitter.com/liskov_learning" target="_blank" rel="noopener noreferrer">
                                <img src={xImage} alt="Twitter (X)Social Media" />
                            </a>
                        </div>
                    </div>
                    <div className="right-footer-link">
                        <div>
                            🚧 faq..
                        </div>
                        {/* <div className="coming-soon">
                            coming soon..
                        </div> */}
                    </div>
                    <div className="right-footer-link">
                        <div>
                            🚧 dev work..
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
  }
  
  export default Footer;